import { ChatIcon, CogIcon, HomeIcon } from "@heroicons/react/outline";

const Footer = () => {
  return (
    <footer className="bg-white py-2 w-full border-t border-gray-300 shadow">
      <div className="flex items-center justify-between px-6">
        <div className="flex items-center flex-col">
          <HomeIcon className="h-7 text-gray-900" />
          <p>Home</p>
        </div>
        <div className="flex items-center flex-col">
          <CogIcon className="h-7 text-gray-900" />
          <p>Rooms</p>
        </div>
        <div className="flex items-center flex-col">
          <ChatIcon className="h-7 text-gray-900" />
          <p>Chat</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
